import './style/drone-A6.scss'


$('.product-video-box .watch-video').click(function () {
  $('.product-video-box .video-mask').show()
  $('.product-video-box .video-mask video').attr('src', 'https://static.qifeizn.com/resources/os/videos/new-A6.mp4');
})
$('.product-video-box .video-close').click(function () {
  $('.product-video-box .video-mask').hide()
  $('.product-video-box .video-mask video').attr('src', '');
})
